import React from 'react';
import no from "../../assets/no.jpg"

const ChequeDetails = (props) => {
    const baseImageUrl = `${process.env.REACT_APP_BASE_URL}`;

    const absoluteImageUrl = baseImageUrl + props.image;

    return (
        <div className="cheque__preview bg-white p-5 rounded-2xl border-4 border-blue-200">
            <div className="p-10">
                {props.image ? (
                    <img src={absoluteImageUrl} alt="" />
                ) : (
                    <img src={no} alt="" />
                )}
            </div>
        </div>
    );
}

export default ChequeDetails;
